// extracted by mini-css-extract-plugin
export default {"more-text":"more-text_more-text__2C5xR","more-text--text":"more-text_more-text--text__3MhmS","_plain":"more-text__plain__1zgon"};